import { useRole } from "../../context/RoleContext";
import { VIEWS } from "../../services/navigation";
import EmployeeDashboard from "./EmployeeDashboard";
import ManagerDashboard from "./ManagerDashboard";
import HrDashboard from "./HrDashboard";
import ManagementDashboard from "./ManagementDashboard";
import AdminDashboard from "./AdminDashboard";
import { NoTableTools } from "../../components/common/DataTable";

export default function DashboardPage() {
  const { activeView } = useRole();
  switch (activeView) {
    case VIEWS.MANAGER:
      return <ManagerDashboard />;
    case VIEWS.HR:
      return <HrDashboard />;
    case VIEWS.MANAGEMENT:
      return <ManagementDashboard />;
    case VIEWS.ADMIN:
      return <NoTableTools><AdminDashboard /></NoTableTools>; // [NEW] no Export / Import on the Admin dashboard
    default:
      return <EmployeeDashboard />;
  }
}
